var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.472 8.288C23.108 3.657 19.223 0 14.5 0C10.46 0 6.992 2.624 5.873 6.451C2.681 7.559 0.5 10.583 0.5 14C0.5 18.411 4.089 22 8.5 22H21.5C25.36 22 28.5 18.86 28.5 15C28.5 11.851 26.43 9.148 23.472 8.288ZM19.424 11.383C19.269 11.756 18.904 12 18.5 12H16.5V16C16.5 17.104 15.604 18 14.5 18C13.396 18 12.5 17.104 12.5 16V12H10.5C10.096 12 9.731 11.756 9.576 11.383C9.421 11.009 9.507 10.579 9.793 10.293L13.793 6.293C13.988 6.098 14.244 6 14.5 6C14.756 6 15.012 6.098 15.207 6.293L19.207 10.293C19.493 10.579 19.579 11.009 19.424 11.383Z",
    fill: "#C1C5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.bb2a4a6c.svg";
export { ForwardRef as ReactComponent };